import { ProductGroups } from "../../../../../../modules/merchant/admin/products/productsTypes"
import { MonetaryAmount } from "../../../../../../modules/currency/currencyTypes"
import { DeliveryTimesField } from "../../form/formTypes"

export function moneyEquals(a: MonetaryAmount, b: MonetaryAmount): boolean {
    if (!a || !b) return false
    return a.amount === b.amount && a.scale === b.scale && a.currency === b.currency
}

export function buildPriceMap(list?: ProductGroups[]): Map<number, MonetaryAmount> {
    const map = new Map<number, MonetaryAmount>()
    for (const group of list ?? []) {
        for (const p of group?.products ?? []) {
            const price = p.price ?? null
            if (price) {
                map.set(p.id, price)
            }
        }
    }
    return map
}

export type SelectedLine = Readonly<{ id: number; price: MonetaryAmount | undefined }>

export function collectSelectedLines(deliveries?: DeliveryTimesField): SelectedLine[] {
    const out: SelectedLine[] = []
    for (const slot of deliveries?.deliveryTimes ?? []) {
        for (const line of slot?.orderLines ?? []) {
            if (!line?.isExtraService && typeof line?.id === "number" && line?.price) {
                out.push({ id: line.id, price: line.price })
            }
        }
    }
    return out
}

export function hasPriceDiff(priceById: Map<number, MonetaryAmount>, selected: SelectedLine[]): boolean {
    for (const { id, price } of selected) {
        const current = priceById.get(id)
        if (!current) continue
        if (!price) return true
        if (!moneyEquals(price, current)) return true
    }
    return false
}

export function updatePricesInDeliveries(
    deliveries: DeliveryTimesField,
    priceById: Map<number, MonetaryAmount>,
): { updated: DeliveryTimesField; changed: boolean } {
    let changed = false

    const updated = {
        ...deliveries,
        deliveryTimes: deliveries.deliveryTimes.map((slot) => {
            let slotChanged = false
            const updatedOrderLines = (slot.orderLines ?? []).map((line) => {
                if (line?.isExtraService || typeof line?.id !== "number") return line

                const currentPrice = priceById.get(line.id)
                const oldPrice = line.price as MonetaryAmount | undefined
                if (!currentPrice || !oldPrice) return line
                if (moneyEquals(oldPrice, currentPrice)) return line

                slotChanged = true
                changed = true
                return { ...line, price: currentPrice }
            })
            return slotChanged ? { ...slot, orderLines: updatedOrderLines } : slot
        }),
    }

    return { updated, changed }
}

export function getProductQuantityFromDeliveries(deliveries: DeliveryTimesField, productId: number): number {
    if (!deliveries?.activeTime) return 0

    const activeDelivery = deliveries.deliveryTimes.find((d) => d.time === deliveries.activeTime)
    if (!activeDelivery) return 0

    const product = activeDelivery.orderLines.find((item) => item.id === productId && !item.isExtraService)

    return product?.quantity || 0
}
